import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import withCustomStyles from "./GField.style";

let uid = 0;

// Label above, filled #F3F3F3 field, radius 12. Optional fixed prefix
// ("+92"), help text, and an error that says what to do.
class GField extends React.Component {
  fallbackId = `gfield-${++uid}`;

  render() {
    const {
      classes,
      className,
      id,
      label,
      optional,
      prefix,
      help,
      error,
      multiline,
      rows,
      inputRef,
      ...inputProps
    } = this.props;
    const fieldId = id || this.fallbackId;
    const errorText = error === true ? null : error;
    const describedBy = errorText || help ? `${fieldId}-desc` : undefined;
    const Tag = multiline ? "textarea" : "input";

    return (
      <div className={classnames(classes.root, className)}>
        {label && (
          <label htmlFor={fieldId} className={classes.label}>
            {label}
            {optional && <span className={classes.optional}> (optional)</span>}
          </label>
        )}
        <div
          className={classnames(classes.box, {
            [classes.hasError]: Boolean(error),
            [classes.disabled]: inputProps.disabled,
            [classes.multiline]: multiline
          })}
        >
          {prefix && (
            <span className={classes.prefix} aria-hidden="true">
              {prefix}
            </span>
          )}
          <Tag
            id={fieldId}
            ref={inputRef}
            rows={multiline ? rows : undefined}
            aria-invalid={Boolean(error) || undefined}
            aria-describedby={describedBy}
            className={classes.input}
            {...inputProps}
          />
        </div>
        {(errorText || help) && (
          <span
            id={describedBy}
            className={classnames(classes.help, {
              [classes.errorText]: Boolean(errorText)
            })}
          >
            {errorText || help}
          </span>
        )}
      </div>
    );
  }
}

GField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  optional: PropTypes.bool,
  prefix: PropTypes.node,
  help: PropTypes.node,
  error: PropTypes.node,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};

GField.defaultProps = {
  type: "text",
  rows: 3
};

export default withCustomStyles(GField);
